import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { IPartnerFees } from '../../merchnts/merchant-interfaces';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { numberFormatter, numberFormatterCount } from '../../../utils/utilities';
import { WhisperComponent } from '../../../components/developers/page-components/WhisperComponent';

export enum PartnerFeesTableAccessorKeys {
	name = 'name',
	appliedOn = 'appliedOn',
	amount = 'amount',
	isActive = 'isActive',
	minimumFeeAmount = 'minimumFeeAmount',
	group = 'group',
	applyOrder = 'applyOrder'
}

export const defaultPartnerFeesColumnSizing: ColumnSizing = {
	[PartnerFeesTableAccessorKeys.name]: 100,
	[PartnerFeesTableAccessorKeys.appliedOn]: 100,
	[PartnerFeesTableAccessorKeys.amount]: 100,
	[PartnerFeesTableAccessorKeys.isActive]: 50,
	[PartnerFeesTableAccessorKeys.minimumFeeAmount]: 100,
	[PartnerFeesTableAccessorKeys.group]: 50,
	[PartnerFeesTableAccessorKeys.applyOrder]: 50,
};

const getFeeAmount = (value: number, type: number): string => {
	if (!value) {
		return '-';
	}
	if (type === 0) {
		return `$${numberFormatter(value)}`;
	} else {
		return `${numberFormatterCount(value)}%`;
	}
};



const getGroupHeader = (
	<div>
		<span className="text-muted fw-bolder main-font-family me-1">Group</span>
		<WhisperComponent
			isTooltip
			whisperText='Defines a collection of fees applied to transactions based on predefined criteria like agreements, risk configurations, or other merchant-related settings.'
			mainText={
				<FontAwesomeIcon
					icon={faQuestionCircle}
					className="cursor-pointer"
					width={12}
				/>
			}
		/>
	</div>
);

export const defaultPartnerFeesColumns: MRT_ColumnDef<IPartnerFees>[] = [
	{
		accessorKey: PartnerFeesTableAccessorKeys.group,
		header: 'Group',
		enableSorting: false,
		// Header: <span className="text-muted fw-bolder main-font-family">Group</span>,
		Header: getGroupHeader,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: PartnerFeesTableAccessorKeys.name,
		header: 'Name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	// {
	// 	accessorKey: PartnerFeesTableAccessorKeys.appliedOn,
	// 	header: 'Applied on',
	// 	enableSorting: false,
	// 	Header: <span className="text-muted fw-bolder main-font-family">Applied on</span>,
	// 	Cell: ({ renderedCellValue, table }: any): JSX.Element => (
	// 		<TableCell
	// 			additionalClass="d-flex align-items-center main-font-family text-black"
	// 			density={table?.options?.state?.density}
	// 			isTextOverflow={false}
	// 		>
	// 			{renderedCellValue ? renderedCellValue : '-'}
	// 		</TableCell>
	// 	)
	// },
	{
		accessorKey: PartnerFeesTableAccessorKeys.amount,
		header: 'Amount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Amount</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getFeeAmount(renderedCellValue / 100, row?.original?.type)}
			</TableCell>
		)
	},
	{
		accessorKey: PartnerFeesTableAccessorKeys.minimumFeeAmount,
		header: 'Minimum fee amount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Minimum fee amount</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue ? `$${numberFormatter(renderedCellValue / 100)}` : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: PartnerFeesTableAccessorKeys.isActive,
		header: 'Is active',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Is active</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue && <FontAwesomeIcon icon={faSquareCheck} width={20} className="text-danger h-20px"/>}
			</TableCell>
		)
	},
];